import { AUTH_URLS, LOGIN_PAGE_URL, PASSWORD_TOKEN_PAGES } from './constants';

// the one-time upload-from-phone page: opened on a phone without signing in
export const isPhoneUploadRoute = (pathname: string) =>
  pathname.startsWith('/upload/');

export const isPublicAuthPage = (pathname: string) => {
  return (
    AUTH_URLS.includes(pathname) ||
    pathname === LOGIN_PAGE_URL ||
    isPhoneUploadRoute(pathname)
  );
};

export const isTrackRoute = (pathname: string) => {
  return pathname.startsWith('/track');
};

export const isPasswordTokenPage = (pathname: string) => {
  return PASSWORD_TOKEN_PAGES.includes(pathname);
};

export const hasTokenParam = (search: string) => {
  const searchParams = new URLSearchParams(search);
  return !!searchParams.get('token');
};

export const shouldSkipAuth = (pathname: string, search: string) => {
  return (
    isPublicAuthPage(pathname) ||
    isTrackRoute(pathname) ||
    (isPasswordTokenPage(pathname) && hasTokenParam(search))
  );
};
